import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Plus, Trash2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { useQuartiers } from "@/hooks/useQuartiers";

export function QuartiersListPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: quartiers, isLoading, isError } = useQuartiers();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 size={24} className="animate-spin text-accent" />
      </div>
    );
  }
  if (isError) {
    return (
      <div className="bg-danger-light border border-danger rounded-md p-4">
        <p className="text-sm text-danger font-medium">{t("parametres.quartiers.loadError")}</p>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-4">
        <Button variant="primary">
          <Plus size={16} />
          {t("parametres.quartiers.add")}
        </Button>
      </div>

      <div className="bg-surface border border-border rounded-lg overflow-hidden">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left px-4 py-3 text-xs font-medium tracking-wider uppercase text-text-muted">{t("common.name")}</th>
              <th className="text-left px-4 py-3 text-xs font-medium tracking-wider uppercase text-text-muted">{t("parametres.quartiers.cities")}</th>
              <th className="text-right px-4 py-3 text-xs font-medium tracking-wider uppercase text-text-muted">{t("common.actions")}</th>
            </tr>
          </thead>
          <tbody>
            {(quartiers ?? []).map((q) => (
              <tr
                key={q.id}
                className="border-b border-border last:border-b-0 hover:bg-gray-100 cursor-pointer transition-colors"
                onClick={() => navigate(`/parametres/quartiers/${q.id}`)}
              >
                <td className="px-4 py-3 text-xs font-medium text-text-primary">{q.nom}</td>
                <td className="px-4 py-3 text-xs text-text-secondary">
                  {(q.codesPostaux ?? []).map((cp) => `${cp.code} ${cp.ville}`).join(", ")}
                </td>
                <td className="px-4 py-3">
                  <div className="flex items-center justify-end">
                    <button
                      className="p-1.5 rounded hover:bg-gray-200 cursor-pointer"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <Trash2 size={14} className="text-text-muted hover:text-danger" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
